module.exports = __webpack_public_path__ + "img/the usual offering box.32afbc95.png";